<script setup>
import { useI18n } from 'vue-i18n';

import Icon from 'dashboard/components-next/icon/Icon.vue';

defineProps({
  compact: {
    type: Boolean,
    default: false,
  },
});

const { t } = useI18n();
</script>

<template>
  <div class="p-3 border rounded-xl border-n-weak bg-n-alpha-1">
    <div class="flex items-start gap-2">
      <span
        class="flex items-center justify-center flex-shrink-0 rounded-full size-5 bg-n-brand/10 text-n-brand"
      >
        <Icon icon="i-lucide-shield-check" class="size-3.5" />
      </span>
      <div class="min-w-0">
        <div class="flex items-center gap-2">
          <p class="mb-0 text-sm font-medium text-n-slate-12">
            {{ t('GROUPS.API_NOTICE.TITLE') }}
          </p>
          <span
            class="rounded-md bg-n-amber-9/10 px-1.5 py-0.5 text-xxs font-medium text-n-amber-11"
          >
            {{ t('GROUPS.API_NOTICE.PENDING') }}
          </span>
        </div>
        <p class="mt-1 mb-0 text-xs text-n-slate-11">
          {{ t('GROUPS.API_NOTICE.DESCRIPTION') }}
        </p>
        <ul
          v-if="!compact"
          class="flex flex-col gap-1 mt-2 mb-0 text-xs ps-4 text-n-slate-11"
        >
          <li>{{ t('GROUPS.API_NOTICE.OBA') }}</li>
          <li>{{ t('GROUPS.API_NOTICE.INVITE_ONLY') }}</li>
          <li>{{ t('GROUPS.API_NOTICE.MAX_PARTICIPANTS') }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>
